import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';

import { FileTypeIconPipe, IconComponent} from '@softline/ui-core';

import { FilesizePipe } from '@softline/ui-core';
import { FormatPipe } from '@softline/ui-core';
@Component({
  selector: 'soft-document',
  imports: [
    FileTypeIconPipe,
    IconComponent,
    FilesizePipe,
    FormatPipe],
  templateUrl: './document.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './document.component.css' })
export class DocumentComponent {
  fileName = input.required<string>();
  lastChanged = input.required<string>();
  read = input.required<boolean>();
  favorite = input.required<boolean>();

  userName = input<string>();
  fileBetreff = input<string>();
  fileSize = input<number>();
  fileDescription = input<string>();

  fileIconClick = output<void>();
}
